<template>
  <div class="">
    <footer class="footer-area black-bg pos-rel text-center text-md-auto pt-50">
      <div class="custom-container">
        <div class="row mb-20">
          <div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2 animated" data-wow-delay=".1s">
            <div class="footer__widget mb-30 text-md-center">
              <div class="footer-log">
                <a href="javascript:;" class="footer-logo" @click="goHome" width="200px">
                  <img loading="lazy" src="/assets/img/logo/footer-logo.png" style="aspect-ratio: 1;" alt="" />
                </a>
              </div>
              <!-- <p v-if="locale == 'ar'">
                                هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد
                                هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو
                                العديد من النصوص الأخرى
                            </p>

                             <p v-if="locale == 'en'">
                              This text is an example of text that can be replaced in the same space. It has been generated
                            This text is from the Arabic text generator, where you can generate such text or many other texts
                            </p> -->

              <div class="top-right-nav mt-30">
                <ul>
                  <li v-for="(social, index) in socials" :key="index">
                    <a :href="social.provider_url" target="_blank">
                      <svg v-if="['twitter', 'x', 'x-twitter'].includes(social.provider)" class="x-icon"
                        viewBox="0 0 24 24" aria-hidden="true">
                        <path
                          d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                      </svg>
                      <i v-else :class="'fab fa-' + social.provider"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2 animated" data-wow-delay=".3s">
            <div class="footer__widget fot_abot mb-30 pl-40">
              <h5 class="semi-02-title mb-25">{{ $t("footer.fast_links") }}</h5>
              <ul class="fot-list">
                <li>
                  <router-link :to="{ name: 'about' }">
                    {{ $t("app.about") }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'news' }">
                    {{ $t("app.news") }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/categories'">
                    {{ $t("app.projects") }}
                  </router-link>
                </li>

              </ul>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2 animated" data-wow-delay=".3s">
            <div class="footer__widget fot_abot mb-30 pl-40">
              <h5 class="semi-02-title mb-25">
                {{ $t("footer.website_map") }}
              </h5>
              <ul class="fot-list">
                <li>
                  <router-link :to="'/gallery'">
                    {{ $t("app.gallery") }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/videos'">
                    {{ $t("app.videos") }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="'/contacts'">
                    {{ $t("app.contact_us") }}
                  </router-link>
                </li>

                <li>
                  <router-link :to="{ name: 'privacypolicy' }">
                    {{ $t("footer.privacy") }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'termsconditions' }">
                    {{ $t("footer.terms") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2 animated" data-wow-delay=".7s">
            <div class="footer__widget fot_abot mb-30 pl-60">
              <h5 class="semi-02-title mb-25">{{ $t("footer.contact_us") }}</h5>
              <ul class="widget_address_list">
                <li>
                  <div class="widget_address d-flex mb-20">
                    <div class="widget_address__icon mr-20">
                      <i class="flaticon-location"></i>
                    </div>
                    <div class="widget_address__content">
                      <h4 class="semi-02-title">{{ $t("footer.location") }}</h4>
                      <span v-html="info.body1"></span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="widget_events d-flex mb-20">
                    <div class="widget_address__icon mr-20">
                      <i class="flaticon-chat"></i>
                    </div>
                    <div class="widget_address__content">
                      <h4 class="semi-02-title">{{ $t("footer.email") }}</h4>
                      <span>
                        <a :href="'mailto:' + info.body3" v-html="info.body3">
                        </a>
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="widget_events d-flex mb-20">
                    <div class="widget_address__icon mr-20">
                      <i class="flaticon-phone-call"></i>
                    </div>
                    <div class="widget_address__content">
                      <h4 class="semi-02-title">
                        <a :href="'tel:' + info.body2">{{ $t("footer.phone") }}
                        </a>
                      </h4>
                      <span>
                        <a :href="'tel:' + info.body2" v-if="locale == 'ar'" v-html="info.body2">
                          <!-- {{ info.body2.replace(/<\/?[^>]+(>|$)/g, '').split('').reverse().join('') }} -->
                        </a>
                      </span>
                      <span>
                        <a :href="'tel:' + info.body2" v-if="locale == 'en'" v-html="info.body2"></a>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--scroll-target-btn-->
        <!-- <a href="#top-menu" class="scroll-target"><i class="far fa-arrow-up"></i></a> -->
        <!--scroll-target-btn-->
      </div>
      <div class="copy-right-area">
        <div class="align-items-center">
          <div class="">
            <div class="copyright text-center">
              <p>
                {{ $t("footer.copyright") }}

                {{ $t("footer.copyright_done") }}
                <span><a href="https://www.gatetechs.com" target="_blank">
                    {{ $t("footer.copyright_company") }}
                  </a></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <!-- <div class="zeropercentage">
      <p class="info">{{ $t("footer.percentage_zero") }}</p>
      <img class="image" src="/assets/img/zero.svg" loading="lazy" />
    </div> -->

    <!-- Search Modal -->
    <div class="modal fade search-popup" id="search-modal" tabindex="-1" role="dialog" aria-labelledby="search-modal"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="select-area mb-10">
              <select class="form-control select-h50 xxx" v-model="category" @change="fetchOptions()">
                <option value="" selected="">
                  {{ $t("app.choose_search") }}
                </option>
                <option value="projects">{{ $t("app.projects") }}</option>

              </select>
            </div>

            <div class="select-area mb-10">
              <div v-if="dataLoading && category" class="text-center" style="">
                <div class="webkit-animation webkit-100per-46"></div>
              </div>
              <select class="form-control select-h50 xxx" v-if="!dataLoading && category" v-model="slug">
                <option v-for="(el, index) in elements" :key="index" :value="el.slug">
                  {{ el.title ? el.title : el.name }}
                </option>
              </select>
            </div>

            <div class="input-btn">
              <button type="button" :disabled="!slug" class="theme_btn theme_btn_bg large_btn" @click="search()">
                {{ $t("app.search") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Models -->
  </div>
</template>

<script>
import sendEvent from "@/helpers/sendEvent";
import { trackAddToCart } from "@/helpers/pixel";
import iziToast from "izitoast";

export default {
  name: "Footer",
  components: {},
  data() {
    return {
      //
      auth: {
        access_token: "",
        user_id: "",
        first_name: "",
        last_name: "",
        email: "",
        avatar: "",
        preview: "",
        password: "",
        ccode: "",
        mobile: "",
        id_number: "",
      },

      locale: "ar",
      pgLoading: true,
      btnLoading: false,
      info: "",
      news: [],
      socials: [],
      categories: [],
      types: [],
      values: [],
      keyword: "",

      type_id: 0,
      amount_id: 1,
      amount: "",
      custom_amount: "",
      currency: "د.ك",

      category: "",
      slug: "",
      dataLoading: true,
      elements: [],

      calculate_amount: "",
      calculate_result: "",
      paymentStatus: 1,
    };
  },
  mounted() { },
  created() {
    // Auth
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("user_id")) {
      this.auth.user_id = localStorage.getItem("user_id");
    }
    if (localStorage.getItem("first_name")) {
      this.auth.first_name = localStorage.getItem("first_name");
    }
    if (localStorage.getItem("last_name")) {
      this.auth.last_name = localStorage.getItem("last_name");
    }
    if (localStorage.getItem("avatar")) {
      this.auth.avatar = localStorage.getItem("avatar");
      this.auth.preview = localStorage.getItem("avatar");
    }
    if (localStorage.getItem("ccode")) {
      this.auth.ccode = localStorage.getItem("ccode");
    }
    if (localStorage.getItem("mobile")) {
      this.auth.mobile = localStorage.getItem("mobile");
    }
    if (localStorage.getItem("email")) {
      this.auth.email = localStorage.getItem("email");
    }
    if (localStorage.getItem("id_number")) {
      this.auth.id_number = localStorage.getItem("id_number");
    }

    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    //
    this.fetchData();
    this.fetchPayment();
  },
  methods: {
    fetchPayment() {
      const options = {
        url: window.baseURL + "/settings/26",
        method: "GET",
      };

      this.$axios(options)
        .then((res) => {
          this.paymentStatus = res.data.status;
        })
        .catch(() => {
          this.paymentStatus = 0;
        })
        .finally(() => { });
    },
    //
    goHome() {
      this.$router.push({ name: "home" });
      this.scrollToTop();
    },

    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/footer",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.info = res.data.info;
          this.socials = res.data.socials;
          this.categories = res.data.categories;
          //this.category = res.data.categories[0].slug;

          this.types = res.data.types;
          this.type_id = res.data.types[0].id;

          this.values = res.data.values;
          this.amount_id = res.data.values[0].id;
          this.amount = res.data.values[0].amount;
        })
        .catch(() => { })
        .finally(() => { });
    },

    fetchOptions() {
      console.log("clicked...");
      this.dataLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      var side = "";
      if (this.category == "postgraduates") {
        side = "postgraduates";
      } else if (this.category == "projects") {
        side = "projects";
      } else if (this.category == "reliefs") {
        side = "reliefs";
      }
      const options = {
        url: window.baseURL + "/" + side,
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          paginate: 1000,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.dataLoading = false;
          this.elements = res.data.rows;
          this.slug = res.data.rows[0].slug;
        })
        .catch(() => { })
        .finally(() => { });
    },

    //
    updateProfile() {
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/me/" + this.auth.user_id,
        method: "PUT",
        data: {
          // row
          first_name: this.auth.first_name,
          last_name: this.auth.last_name,
          email: this.auth.email,
          ccode: this.auth.ccode,
          mobile: this.auth.mobile,
          id_number: this.auth.id_number,
          password: this.auth.password,

          // image
          image: this.auth.avatar,
        },
      };
      this.$axios(options)
        .then(() => {
          this.btnLoading = false;

          iziToast.success({
            icon: "ti-check",
            title: "Great job,",
            message: "Profile Updated Successfully",
          });

          localStorage.setItem("first_name", this.auth.first_name);
          localStorage.setItem("last_name", this.auth.last_name);
          localStorage.setItem("avatar", this.auth.avatar);
          localStorage.setItem("ccode", this.auth.ccode);
          localStorage.setItem("mobile", this.auth.mobile);
          localStorage.setItem("email", this.auth.email);
          localStorage.setItem("id_number", this.auth.id_number);

          //
          this.closePopup();
        })
        .catch((err) => {
          this.btnLoading = false;
          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: err.response ? this.$t("app.error_contact_us") : "" + err,
          });
        })
        .finally(() => {
          this.closePopup();
        });
    },

    onImageChange(e) {
      const file = e.target.files[0];
      this.auth.preview = URL.createObjectURL(file);
      this.createBase64Image(file);
    },

    createBase64Image(fileObject) {
      const reader = new FileReader();
      reader.readAsDataURL(fileObject);
      reader.onload = (e) => {
        this.auth.avatar = e.target.result;
      };
    },

    search() {
      this.closePopup();

      var side = "";
      if (this.category == "orphans") {
        side = "show-orphans";
      } else if (this.category == "preachers") {
        side = "show-preachers";
      } else if (this.category == "postgraduates") {
        side = "show-postgraduates";
      } else if (this.category == "projects") {
        side = "show-projects";
      } else if (this.category == "reliefs") {
        side = "show-reliefs";
      }

      this.category = "";

      this.$router.push({
        name: side,
        params: { slug: this.slug },
      });

      this.slug = "";
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    closePopup() {
      // editprofile popup
      // let popup0 = document.querySelectorAll("div.edit-profile-popup");
      // let app0 = popup0[popup0.length-1];
      // if(app0.classList.contains('show')) {
      //     app0.classList.remove('show');
      // }

      // donation popup
      let popup1 = document.querySelectorAll("div.donation-popup");
      let app1 = popup1[popup1.length - 1];
      if (app1.classList.contains("show")) {
        app1.classList.remove("show");
      }

      // search popup
      let popup2 = document.querySelectorAll("div.search-popup");
      let app2 = popup2[popup2.length - 1];
      if (app2.classList.contains("show")) {
        app2.classList.remove("show");
      }

      // profile popup
      // let popup3 = document.querySelectorAll("div.edit-profile-popup");
      // let app3 = popup1[popup3.length-1];
      // if(app3.classList.contains('show')) {
      //     app3.classList.remove('show');
      // }

      // backdrop
      let close = document.querySelectorAll("div.modal-backdrop");
      let backdrop = close[close.length - 1];
      if (backdrop.classList.contains("show")) {
        backdrop.classList.remove("show");
        backdrop.classList.remove("modal-backdrop");
      }

      // Body
      let body = document.querySelectorAll("body");
      let ch = body[body.length - 1];
      if (ch.classList.contains("modal-open")) {
        ch.classList.remove("modal-open");
      }
    },

    addToCart() {
      // paymentStatus
      if (this.paymentStatus == 0) {
        iziToast.warning({
          icon: "ti-alert",
          title: "",
          message: this.$t("app.payment_status_error"),
        });
        return false;
      }

      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      let amount_total = this.amount;
      if (this.custom_amount.length) {
        amount_total = this.custom_amount;
      }
      const options = {
        url: window.baseURL + "/carts",
        method: "POST",
        data: {
          model_id: "",
          model_type: "",
          type_id: this.type_id,
          amount: amount_total,
        },
        params: {},
      };
      this.$axios(options)
        .then(() => {
          this.btnLoading = false;
          sendEvent("AddToCart", amount_total);
          trackAddToCart({
            value: amount_total,
            currency: "KWD",
            content_ids: this.type_id ? [this.type_id] : [],
            content_type: "general_donation",
          });
          iziToast.success({
            icon: "ti-check",
            title: "Great job,",
            message: this.$t("app.add_msg"),
          });

          if (this.$route.path == "/carts") {
            this.$router.go(this.$router.currentRoute);
          } else {
            this.$router.push({ name: "carts" });
          }
        })
        .catch((err) => {
          this.btnLoading = false;
          if (err.response && err.response.status == 401) {
            this.removeLocalStorage();
            this.$router.push({ name: "login" });
          } else {
            iziToast.warning({
              icon: "ti-alert",
              title: "",
              message: err.response ? this.$t("app.add_fail") : "" + err,
            });
          }
        })
        .finally(() => {
          this.closePopup();
        });
    },

    removeLocalStorage() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_image");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("user_id");
      localStorage.removeItem("email");
      localStorage.removeItem("id_number");
    },

    changeAmount: function (id, amount) {
      this.amount = amount;
      this.amount_id = id;
      this.custom_amount = "";
    },

    changeType: function (id) {
      this.type_id = id;
    },

    countryChanged(country) {
      this.auth.ccode = country.dialCode;
    },

    calculate() {
      this.calculate_result = (this.calculate_amount * 2.5) / 100;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.x-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  vertical-align: -0.125em;
}

.select-h50 {
  height: 55px !important;
  border-radius: 0;
  outline: none !important;
  box-shadow: none;
}

.select-h50:focus {
  outline: none !important;
}

.footer-logo img {
  aspect-ratio: 2 !important;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

.widget_address__icon i {
  font-size: 28px !important;
}

.semi-02-title {
  font-size: 19px !important;
}

@media (max-width: 768px) {
  .widget_address_list {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .footer-log a {
    width: 150px;
    margin-bottom: -25px;
  }
}

.custom-container {
  width: 90%;
}
</style>
